(function (jQuery, Drupal) {
  'use strict';
  var once = true;
  Drupal.behaviors.accessories = {
    attach: function (context, settings) {
      var once = false;
      var $page = jQuery('body.page-node-type-page-accessories');
      if ($page.length > 0) {
        var $popup = $page.find('article.node--type-page-accessories.node--view-mode-full .popup');
        $popup.find('.close').click(function () {
          $popup.find('.popup-inner').html('');
          $popup.hide();
        });
        $page.find('article.node--type-page-accessories.node--view-mode-full .paragraph--type--section-accessories .paragraph--type--accessory-item')
          .each(function (index, element) {
            var $element = jQuery(element);
            $element.find('.read-more a').click(function (event) {
              event.preventDefault();
              var markup = $element.find('.field--name-field-image')[0].outerHTML + $element.find('.field--name-field-title')[0].outerHTML + $element.find('.field--name-field-long-text')[0].outerHTML;
              $popup.find('.popup-inner').html(markup);
              var top = Math.min(jQuery('footer')
                  .position().top - $popup.height() - jQuery('header')
                  .height() - jQuery('.region.region-breadcrumb')
                  .height() - 80, Math.max(window.scrollY - jQuery('header')
                  .height() - jQuery('.region.region-breadcrumb')
                  .height() + (jQuery(window)
                  .height() - $popup.height() - 48) / 2, window.scrollY - jQuery('header')
                  .height() - jQuery('.region.region-breadcrumb')
                  .height() + 32));
              $popup.css('top', top + 'px');
              $popup.show();
            });
          });
      }
    }
  }
})(jQuery, Drupal);
